export const accessTokenInfo = () => {
    const accessToken = localStorage.getItem('accessToken')
    
    let accessInfo = {
         headers: {'X-ETA-ACCESS-TOKEN': accessToken}
    };

    return accessInfo
}


// WEBPACK FOOTER //
// ./src/store/accessToken.js